import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HighchartsChartModule } from 'highcharts-angular';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { ExcelUploaderComponent } from 'src/app/shared/component/excel-uploader/excel-uploader.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CompanyCrudComponent } from './company/company-crud/company-crud.component';
import { CompanyListComponent } from './company/company-list/company-list.component';
import { EmployeeCrudComponent } from './employee/employee-crud/employee-crud.component';
import { EmployeeListComponent } from './employee/employee-list/employee-list.component';
import { EpochCrudComponent } from './epoch/epoch-crud/epoch-crud.component';
import { EpochListComponent } from './epoch/epoch-list/epoch-list.component';
import { FamilyCrudComponent } from './family/family-crud/family-crud.component';
import { FamilyListComponent } from './family/family-list/family-list.component';
import { HolidayCrudComponent } from './holiday/holiday-crud/holiday-crud.component';
import { HolidayListComponent } from './holiday/holiday-list/holiday-list.component';
import { EmployeeInsuranceCrudComponent } from './insurance-employee/employee-insurance-crud/employee-insurance-crud.component';
import { EmployeeInsuranceListComponent } from './insurance-employee/employee-insurance-list/employee-insurance-list.component';
import { InsuranceCrudComponent } from './insurance/insurance-crud/insurance-crud.component';
import { InsuranceListComponent } from './insurance/insurance-list/insurance-list.component';
import { MediumCrudComponent } from './medium/medium-crud/medium-crud.component';
import { MediumListComponent } from './medium/medium-list/medium-list.component';
import { MetricsCrudComponent } from './metrics/metrics-crud/metrics-crud.component';
import { MetricsListComponent } from './metrics/metrics-list/metrics-list.component';
import { PerformanceCrudComponent } from './performance/performance-crud/performance-crud.component';
import { PerformanceListComponent } from './performance/performance-list/performance-list.component';
import { ChangePasswordComponent } from './profile/change-password/change-password.component';
import { CompanyProfileComponent } from './profile/my-account/company-profile/company-profile.component';
import { EmployeeProfileComponent } from './profile/my-account/employee-profile/employee-profile.component';
import { ProfileComponent } from './profile/profile.component';
import { QuarterCrudComponent } from './quarter/quarter-crud/quarter-crud.component';
import { QuarterListComponent } from './quarter/quarter-list/quarter-list.component';
import { RoleCrudComponent } from './role/role-crud/role-crud.component';
import { RoleListComponent } from './role/role-list/role-list.component';
import { SetupRoutingModule } from './setup-routing.module';
import { SocialMediaCrudComponent } from './social/social-media-crud/social-media-crud.component';
import { SocialMediaListComponent } from './social/social-media-list/social-media-list.component';
import { TitleCrudComponent } from './title/title-crud/title-crud.component';
import { TitleListComponent } from './title/title-list/title-list.component';
import { UserCrudComponent } from './user/user-crud/user-crud.component';
import { UserListComponent } from './user/user-list/user-list.component';
import { WorkdayCrudComponent } from './workday/workday-crud/workday-crud.component';
import { WorkdayListComponent } from './workday/workday-list/workday-list.component';


@NgModule({
  declarations: [
    CompanyCrudComponent,
    CompanyListComponent,
    HolidayCrudComponent,
    HolidayListComponent,
    WorkdayListComponent,
    WorkdayCrudComponent,
    RoleCrudComponent,
    RoleListComponent,
    UserListComponent,
    UserCrudComponent,
    TitleCrudComponent,
    TitleListComponent,
    EmployeeListComponent,
    EmployeeCrudComponent,
    FamilyCrudComponent,
    FamilyListComponent,
    ProfileComponent,
    MediumCrudComponent,
    MediumListComponent,
    ChangePasswordComponent,
    EmployeeProfileComponent,
    CompanyProfileComponent,
    EpochCrudComponent,
    EpochListComponent,
    QuarterListComponent,
    QuarterCrudComponent,
    ExcelUploaderComponent,
    InsuranceListComponent,
    InsuranceCrudComponent,
    EmployeeInsuranceListComponent,
    EmployeeInsuranceCrudComponent,
    SocialMediaListComponent,
    SocialMediaCrudComponent,
    MetricsListComponent,
    MetricsCrudComponent,
    PerformanceListComponent,
    PerformanceCrudComponent,
  
  ],
  imports: [
    CommonModule,
    SetupRoutingModule,
    PerfectScrollbarModule,
    HighchartsChartModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ]
})
export class SetupModule { }
